import type { DataRouter } from 'react-router-dom';

import type { Store } from '@/types/store';

import { attachRouterAtom } from './ui/shellLocationAtoms';
import { seedShellRecordAtom } from './ui/shellRecordAtoms';

/**
 * Gives a new store what must be readable before anything in it loads: the shell's stored
 * record, and the router, so the shell's first render reads the location that the URL holds.
 * The record comes before the router: the router's first state copies into the record.
 */
export function seedStore(store: Store, router: DataRouter): void {
    store.set(seedShellRecordAtom);
    store.set(attachRouterAtom, router);
}
